import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";

import { qrListPickerValidations, qrNameValidation } from "./shared";
import { I_QREditorFormTemplate } from "@/data/types/pages";
import { TFunction } from "i18next";
import { EMAIL_PATTERN } from "./patterns";

export const qrVcardValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "fullName",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("fullName", "required", data),
        },
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("fullName", "maxLength", data),
        },
      },
    },
    {
      name: "email",
      rules: {
        pattern: {
          value: EMAIL_PATTERN,
          message: getRuleErrorMessage("email", "pattern", data),
        },
      },
    },
    {
      name: "summary",
      rules: {
        maxLength: {
          value: 250,
          message: getRuleErrorMessage("summary", "maxLength", data),
        },
      },
    },
    {
      name: "website",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("website", "pattern", data),
        },
      },
    },
    {
      name: "address",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("address", "maxLength", data),
        },
      },
    },
    {
      name: "numeration",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("numeration", "maxLength", data),
        },
      },
    },
    {
      name: "zipCode",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("zipCode", "maxLength", data),
        },
      },
    },
    {
      name: "city",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("city", "maxLength", data),
        },
      },
    },
    {
      name: "state",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("state", "maxLength", data),
        },
      },
    },
    {
      name: "country",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("country", "maxLength", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
